import {
  makeGetWithoutToken,
  makeGetWithParam,
  makePost,
  makeDelete,
  makePut,
  makeGet
} from './ServiceManager';

export const getDashboards = async () => {
  const result = await makeGetWithoutToken(
    'service/dashboard/dashboards',
    null,
    ''
  );
  return result;
};

export const insertDashboard = async (dashboard) => {
  const result = await makePost('service/dashboard/dashboard', { dashboard });
  return result;
};

export const updateDashboard = async (dashboard) => {
  const result = await makePut('service/dashboard/dashboard', { dashboard });
  return result;
};

export const removeDashboard = async (id) => {
  const result = await makeDelete('service/dashboard/dashboard', { id });
  return result;
};
export const getDashboardTags = async () => {
  const result = await makeGet('service/dashboard/tags');
  return result;
};

// eslint-disable-next-line consistent-return
export const getDashboardTagsWithFilter = async (tagId) => {
  try {
    const result = await makeGetWithParam(
      'service/dashboard/tags',
      null,
      tagId
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const insertDashboardTags = async (dashboardId, dashboardTags) => {
  const result = await makePost('service/dashboard/tags', {
    dashboardId,
    dashboardTags
  });
  return result;
};

export const updateDashboardTag = async (dashboardId, dashboardTags) => {
  const result = await makePut('service/dashboard/tags', {
    dashboardId,
    dashboardTags
  });
  return result;
};

export const removeDashboardTags = async (dashboardId) => {
  const result = await makeDelete('service/dashboard/tags', { dashboardId });
  return result;
};



// WEBPACK FOOTER //
// ./src/services/DashboardService.js